import { render, staticRenderFns } from "./Digitalinfra.vue?vue&type=template&id=5cadb4bc&"
import script from "./Digitalinfra.vue?vue&type=script&lang=js&"
export * from "./Digitalinfra.vue?vue&type=script&lang=js&"
import style0 from "./Digitalinfra.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports